<template>
  <div class="promotions-slider-component">
    <h1 class="promotions-slider-title font-weight-regular">
      Акции:
    </h1>

    <loader v-if="loading"/>
    <div class="promotions-slider" v-else>
      <swiper ref="swiper" :options="sliderOptions">
        <swiper-slide
          v-for="item in promotions"
          :key="item.id"
        >
          <div v-if="item.mobileImage" class="promotion d-flex align-center justify-center">
            <img class="promotion__image" v-if="item.mobileImage" :src="item.mobileImage" :alt="item.name">
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-button swiper-button-prev"></div>
      <div class="swiper-button swiper-button-next"></div>
    </div>
  </div>
</template>

<script>
  import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
  import 'swiper/css/swiper.css'
  import Loader from '@/components/loader/Loader.vue'

  export default {
    name: 'PromotionsSlider',
    components: {
      Loader,
      Swiper,
      SwiperSlide,
    },
    props: {
      sliderOptions: {
        type: Object,
        default () {
          return {
            slidesPerView: 4,
            // slidesPerGroup: 4,
            spaceBetween: 20,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            keyboard: {
              enabled: true,
            },
            breakpoints: {
              1904: {
                slidesPerView: 4,
              },
              768: {
                slidesPerView: 3,
              },
              0: {
                slidesPerView: 1,
              },
            },
          }
        },
      },
    },
    data () {
      return {
        loading: false,
        promotions: [],

      }
    },
    methods: {
      async fetchPromotions () {
        this.loading = true
        this.$store.dispatch('promotions/fetchPromotionsList')
          .then(res => {
            this.promotions = res.data.items
          })
          .catch(e => {
            this.showErrorFromResponse(e)
          })
          .finally(() => {
            this.loading = false
          })
      },
    },
    created () {
      this.fetchPromotions()
    },
  }
</script>

<style lang="less" scoped>
.promotions-slider-component {
  margin-bottom: 40px;
  font-size: 12px;

  .media-xl({
    font-size: 14px;
  });

  .promotions-slider-title {
    font-size: 2em;
    line-height: 0.8;
    margin-bottom: 33px;
  }

  .promotion {
    &__image {
      display: block;
      max-width: 100%;
      border-radius: 30px;
    }
  }
  .promotions-slider {
    position: relative;
    padding: 0 40px;

    .swiper-button {
      color: #3500ff;

      &-prev {
        left: 0;

      }
      &-next {
        right: 0;
      }
    }

  }
}

</style>
